import React, { useState } from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

export default function Tooltip({ children, label = 'More info' }) {
  const [open, setOpen] = useState(false);

  return (
    <span className="relative inline-block">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        className="inline-flex items-center text-ink/68 hover:text-primary transition-colors"
        aria-label={label}
      >
        <InformationCircleIcon className="w-4 h-4" />
      </button>
      {open && (
        <span
          role="tooltip"
          className="absolute z-20 left-1/2 -translate-x-1/2 mt-2 w-64 p-3 bg-yellow-100 border-2 border-ink rounded-sketch shadow-sketch font-note text-note text-ink leading-snug -rotate-1"
        >
          {children}
        </span>
      )}
    </span>
  );
}
